import { DataBean } from "../DataBean";

export class PayrollToPayroll extends DataBean {

    public async setElectronicPayrollToPayrollFactor(idPayrollFactor: any, idElectronicPayroll: any,): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.PayrollFactor_setElectronicPayrollToPayrollFactor_Number_Number", [idPayrollFactor, idElectronicPayroll]);
    }

}